import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container" ]

  connect() {
    // console.log("Hello, Athlete Degrees Controller here!", this.element)
    // console.log(this.containerTarget)
  }

  addDegree(event) {
    fetch('/degrees').then(res => res.text()).then(partial => {
      this.containerTarget.insertAdjacentHTML( 'beforeend', partial );
    });
  }
}
